export default __webpack_public_path__ + "static/media/_DSC0243.8a4eb9d1.JPG";